import { graphql } from '@/shared/graphql/router'

export const CHECKER_DETECTION_RESULT_FRAGMENT = graphql(`
  fragment CheckerDetectionResult on DnaDetectionResult {
    infringementMatchIds
    outcome
    completeCoverage
    incompleteReason
    windowSeconds
    capturedAudioSeconds
    processedAudioSeconds
    baseFingerprintProcessed
    findings {
      fileDataId
      registrationId
      algorithm
      modality
      scorePercent
      score
      scoreKind
      validationPending
      riskLevel
      strict
      audioCompositionEvidence {
        policyScore
        policyMargin
        rawScore
        referenceStartSeconds
        supporting
        supportKind
        confirmed
        exactLaneMatch
        arm
        rule
        modelVersion
        policyId
      }
      copyrightId
      title
      url
      metadataStatus
    }
  }
`)

export const START_DNA_CAPTURE_MUTATION = graphql(`
  mutation StartDnaCapture($input: DnaCaptureInput!) {
    startDnaCapture(input: $input) {
      id
      expiresAt
      batchSeconds
      minAudioSeconds
      windowSeconds
      maxAudioSeconds
      maxBatchBytes
    }
  }
`)

export const DETECT_DNA_CAPTURE_BATCH_MUTATION = graphql(`
  mutation DetectDnaCaptureBatch($input: DnaCaptureBatchInput!) {
    detectDnaCaptureBatch(input: $input) {
      ...CheckerDetectionResult
    }
  }
`)

export const STOP_DNA_CAPTURE_MUTATION = graphql(`
  mutation StopDnaCapture($id: ID!) {
    stopDnaCapture(id: $id) {
      success
      result {
        ...CheckerDetectionResult
      }
    }
  }
`)

export const CREATE_DNA_DETECTION_MULTIPART_UPLOAD_MUTATION = graphql(`
  mutation CreateDnaDetectionMultipartUpload(
    $input: DnaDetectionMultipartUploadInput!
  ) {
    createDnaDetectionMultipartUpload(input: $input) {
      id
      expiresAt
      maxBytes
      sizeBytes
      partSizeBytes
      partCount
      parts {
        partNumber
        url
      }
    }
  }
`)

export const SIGN_DNA_DETECTION_UPLOAD_PARTS_MUTATION = graphql(`
  mutation SignDnaDetectionUploadParts(
    $input: DnaSignDetectionUploadPartsInput!
  ) {
    signDnaDetectionUploadParts(input: $input) {
      partNumber
      url
    }
  }
`)

export const START_DNA_FILE_DETECTION_MUTATION = graphql(`
  mutation StartDnaFileDetection($id: ID!) {
    startDnaFileDetection(id: $id) {
      id
      status
    }
  }
`)

export const CANCEL_DNA_FILE_DETECTION_MUTATION = graphql(`
  mutation CancelDnaFileDetection($id: ID!) {
    cancelDnaFileDetection(id: $id) {
      id
      status
    }
  }
`)

export const DNA_FILE_DETECTION_QUERY = graphql(`
  query DnaFileDetection($id: ID!) {
    dnaFileDetection(id: $id) {
      id
      status
      totalBytes
      transferredBytes
      windowsDone
      windowsTotal
      result {
        ...CheckerDetectionResult
      }
      error {
        code
        retryable
      }
    }
  }
`)
